// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12L-5","badges":"styles_badges__3RZ5h"};